import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/envelope.svg'


const _withScopeId = n => (_pushScopeId("data-v-74bfb5de"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "contact-us"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "h2" }
const _hoisted_4 = { class: "lead" }
const _hoisted_5 = {
  key: 0,
  class: "contact-box"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Engenious Sp. z o. o.", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "contact-box__data" }, [
  /*#__PURE__*/_createElementVNode("address", null, [
    /*#__PURE__*/_createTextVNode("31-123 Kraków, Poland"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("Krupnicza 3")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "text-primary",
      href: "mailto:hello@engenious.pl"
    }, "hello@engenious.pl")
  ])
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "contact-box__numbers" }, [
  /*#__PURE__*/_createElementVNode("div", null, "NIP: 6772396254"),
  /*#__PURE__*/_createElementVNode("div", null, "REGON: 363242905"),
  /*#__PURE__*/_createElementVNode("div", null, "KRS: 0000592144")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  width: "839",
  height: "912",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_11 = [
  _hoisted_6,
  _hoisted_7,
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"contact-box\" data-v-74bfb5de><h3 data-v-74bfb5de>Engenious AG</h3><div class=\"contact-box__data\" data-v-74bfb5de><address data-v-74bfb5de>Baarerstrasse 10, 6300 Zug<br data-v-74bfb5de>ZG, Switzerland</address><div data-v-74bfb5de><a class=\"text-primary\" href=\"mailto:hello@engenious.ch\" data-v-74bfb5de>hello@engenious.ch</a></div></div><hr data-v-74bfb5de><div class=\"contact-box__numbers\" data-v-74bfb5de><div data-v-74bfb5de>CHE-468.218.726</div></div><img width=\"839\" height=\"912\" src=\"" + _imports_0 + "\" alt=\"\" data-v-74bfb5de></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_thumb = _resolveComponent("thumb")!

  return (_ctx.page)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createVNode(_component_thumb, {
              file: _ctx.page?.additionalThumb1,
              size: 'large'
            }, null, 8, ["file"])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.page?.title), 1),
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.page?.lead), 1),
            (!_ctx.isCh)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_11))
              : _createCommentVNode("", true),
            _hoisted_12
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}